/**
 * Court Desk league nicknames.
 * City names are the canonical city; nicknames are the franchise identity.
 */
export const DESKTOP_NICKNAMES_BY_ABBREV: Record<string, string> = {
	ATL: "Hammers",
	BAL: "Admirals",
	BOS: "Revolution",
	CHI: "Union",
	CIN: "Royals",
	CLE: "Rockers",
	DAL: "Pegasus",
	DEN: "Mountaineers",
	DET: "Mustangs",
	HOU: "Apollos",
	LV: "Jokers",
	LA: "Stars",
	MXC: "Aztecs",
	MIA: "Vice",
	MIN: "Muskies",
	MON: "Voyageurs",
	NYC: "Titans",
	PHI: "Liberty",
	PHO: "Scorpions",
	PIT: "Riveters",
	POR: "Pioneers",
	SAC: "Solons",
	SD: "Surf",
	SF: "Seals",
	SEA: "Storm",
	STL: "Archers",
	TPA: "Marauders",
	TOR: "Huskies",
	VAN: "Mounties",
	WAS: "Senators",
};

export const applyDesktopNicknames = <T extends { name: string; abbrev?: string }>(
	teams: T[],
): T[] =>
	teams.map((t) => {
		const nick =
			t.abbrev != null ? DESKTOP_NICKNAMES_BY_ABBREV[t.abbrev] : undefined;
		return nick != null ? { ...t, name: nick } : t;
	});
